import { useTranslation } from 'react-i18next';
import { InfiosAlert, InfiosButton, InfiosIcon } from '@infios/uikit/react';
import styles from './ErrorBanner.module.css';

interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
  onDismiss?: () => void;
}

/** Inline, dismissible error surface shown above the composer. */
export function ErrorBanner({ message, onRetry, onDismiss }: ErrorBannerProps) {
  const { t } = useTranslation();
  return (
    <InfiosAlert variant="danger" open closable={Boolean(onDismiss)} onInfiosHide={onDismiss} className={styles.banner}>
      <InfiosIcon slot="icon" name="alert-circle" />
      <span className={styles.message}>{message}</span>
      {onRetry ? (
        <InfiosButton slot="action" variant="ghost" size="compact" className={styles.action} onClick={onRetry}>
          {t('ChatbotUI.Retry')}
        </InfiosButton>
      ) : null}
    </InfiosAlert>
  );
}
